import { Container } from '@purpur/library';
import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

type BlockProps = {
    $boxed?: boolean;
    $centered?: boolean;
};

export const StyledBlockCta = styled.div<BlockProps>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('400')};

    ${({ $boxed }) =>
        $boxed &&
        css`
            background-color: ${getPurpurColor('backgroundSecondary')};
            padding: ${getPurpurSpacing('400')};
            border-radius: ${getPurpurBorder('radiusMd')};
            border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderStrong')};
        `}

    ${({ $centered }) =>
        $centered &&
        css`
            align-items: center;
            text-align: center;
        `}
`;

export const StyledBlockCtaContainer = styled(Container)`
    padding-top: ${getPurpurSpacing('400')};
    padding-bottom: ${getPurpurSpacing('400')};

    ${purpurMedia('md')`
        padding-top: ${getPurpurSpacing('600')};
        padding-bottom: ${getPurpurSpacing('600')};
    `};
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('100')};
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};
    flex-direction: column;

    ${purpurMedia('md')`
        flex-direction: row;
        align-items: flex-start;
    `};
`;
